var settings = require('ofs/settings');

var sourceMap = {
    "header enquiry": "ev_Header_or_Footer_Contact",
    "responsive enquire home availability": "ev_Home_listing_Contact",
    "responsive ask a question": "ev_Home_listing_Contact",
    "enquire home availability": "ev_Home_listing_Contact",
    "enquire booking checkout": "ev_Check_Out_Footer_Contact",
    "enquire booking": "ev_Header_or_Footer_Contact",
    "enquire home": "ev_Home_listing_Contact",
    "enquire home property": "ev_Home_listing_Contact",
    "ask a question": "ev_Home_listing_Contact",
    "search enquiry": "ev_Search_Results_Enquiry_button",
    "footer enquiry": "ev_Header_or_Footer_Contact",
    "payment method telephone": "ev_Check_Out_Summary_Contact"
};

var trackAdobe = function(source) {
    var convertedSource = sourceMap[source] || encodeURIComponent(source);
    if (settings.tracking.gactive && settings.tracking.adobePixelTracking) {
        var src = "http://pixel.everesttech.net/3818/t?" + convertedSource + "=1";
        var img = document.createElement("img");
        img.src = src;
        img.width = 1;
        img.height = 1;
        img.style.position = "absolute";
        img.style.visibility = "hidden";
        document.body.appendChild(img);
    } else {
        console.log('Adobe pixel tracking disabled', convertedSource);
    }
};

module.exports = trackAdobe;


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/core/utils/tracking/adobe.js
 **/